// i18n TypeScript type definitions
export type Language = 'zh-HK' | 'en';

export interface LanguageOption {
  code: Language;
  label: string;
  nativeLabel: string;
}

export const LANGUAGES: LanguageOption[] = [
  { code: 'zh-HK', label: 'Traditional Chinese', nativeLabel: '繁中' },
  { code: 'en', label: 'English', nativeLabel: 'EN' },
];

export const DEFAULT_LANGUAGE: Language = 'zh-HK';
